<template>
  <div :class="['code-input', { 'is-error': isError }]" @click="$emit('click')">
    <div
      v-for="num in 6"
      :key="num"
      class="code-item"
    >
      <template v-if="!passNumber">
        <div v-if="password[num - 1]" class="password_input"><div class="poinit" /></div>
      </template>
      <template v-else>
        <div v-if="password[num - 1]" class="password_input">{{ password[num - 1] }}</div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputCode',

  props: {
    value: {
      type: [String, Number, Array],
      default: ''
    },
    password: {
      type: String,
      default: ''
    },
    passNumber: {
      type: Boolean,
      default: false
    },
    isError: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.code-input {
  display: flex;
  justify-content: space-between;
  width: 100%;

  .code-item {
    width: 96px;
    height: 96px;
    line-height: 96px;
    text-align: center;
    border: thin solid #e5e5e5;
    border-radius: 4px;
    font-size: 48px;
    font-weight: 500;
    color: #000;
    display: flex;
    align-items: center;
    justify-content: center;

    .poinit {
      display: block;
      height: 20px;
      width: 20px;
      border-radius: 50%;
      background-color: #111a34;
    }
  }

  &.is-error {
    .code-item {
      border-color: #fa5151;
      border-width: 2px;
    }
  }
}

</style>
